import React, { useEffect, useState } from "react";
import {
  Outlet,
  useLocation,
  useOutletContext,
  useParams,
} from "react-router-dom";
import ContentHeader from "../ContentHeader";
import Style from "./Projects.module.scss";
import { useFPAUploadModal } from "../../../Logic/FPA Uploader/useFPAUploadModal";
import { useDispatch, useSelector } from "react-redux";
import {
  uploadModalAction,
  openMinimizedBox,
  clearThumbs,
} from "../../../store/slices/Gallery/gallerySlice";

import {
  uploadFPAModalAction,
  clearFPAThumbs,
  openFPAMinimizedBox,
} from "../../../store/slices/Gallery/galleryFPAupload";

import ImageUploadMinimized from "../ImageUploadMinimized";
import ImageUploadModal from "../../Modals/ImageUploadModal";
import FPAImageUploadModal from "../../Modals/FPAImageUploadModal";
import { useUploadModal } from "../../../Logic/Uploader/useUploadModal";
import { currentTabHandler } from "../../../store/slices/Project/ProjectSlice";

const Projects = () => {
  const [isGrid, setIsGrid] = useState(true);
  const [isCollapsed] = useOutletContext();
  const [isShowImageUpload, setIsShowImageUpload] = useState(false);
  const dispatch = useDispatch();
  const location = useLocation();

  const [isFpa, setIsFpa] = useState(false);

  const { FPAupload } = useSelector((state) => state);
  let { folderID } = useParams();

  useEffect(() => {
    return () => {
      dispatch(currentTabHandler({ tab: "activeTab", callback: () => {} }));
    };
  }, []);
  const {
    openUploadFPAModal,
    handleDragOver: handleDragOverFPA,
    handleDragOut: handleDragOutFPA,
    handleDrop: handleDropFPA,
    handleImageChange: handleImageChangeFPA,
    thumbs: thumbsFPA,
    activeUploadPercent: activeUploadPercentFPA,
    activeUploadIndex: activeUploadIndexFPA,
    closeUploadModal: handleCloseFPAModal,
    cancelUpload: cancelUploadFPA,
    closeUploadModalWhenDone: closeUploadModalWhenDoneFPA,
    handleCloseFPAMiniMizedModal,
    allFiles: allFilesFPA,
    uploadIndex: uploadIndexFPA,
    duplicateImages: duplicateImagesFPA,
    invalidImages: invalidImagesFPA,
    images: imagesFPA,
    allFilesCount,
  } = useFPAUploadModal();

  return (
    <div
      className={`${Style.Projects} ${
        isShowImageUpload ? Style.Projects_active_imageupload : ""
      }`}
    >
      <ContentHeader isGrid={isGrid} setIsGrid={setIsGrid} />
      <Outlet context={[isGrid, isCollapsed]} />

      {/* <FPAImageUploadModal
        // showModal={true}
        showModal={openUploadFPAModal}
        setShowModal={handleCloseFPAModal}
        handleDragOver={handleDragOverFPA}
        handleDragOut={handleDragOutFPA}
        handleDrop={handleDropFPA}
        handleImageChange={handleImageChangeFPA}
        thumbs={thumbsFPA}
        activeUploadPercent={activeUploadPercentFPA}
        activeUploadIndex={activeUploadIndexFPA}
        closeUploadModal={handleCloseFPAModal}
        cancelUpload={cancelUploadFPA}
        closeUploadModalWhenDone={closeUploadModalWhenDoneFPA}
        allFiles={allFilesFPA}
        uploadIndex={uploadIndexFPA}
        duplicateImages={duplicateImagesFPA}
        invalidImages={invalidImagesFPA}
        images={imagesFPA}
      />
      {FPAupload.openFPAMiniBox && (
        <ImageUploadMinimized
          setIsShowImageUpload={handleCloseFPAMiniMizedModal}
          uploadData={imagesFPA}
          // uploadIndex={FPAupload.activeUploadIndex}
          percentage={FPAupload.activeUploadPercent}
          images={imagesFPA}
          duplicateImages={duplicateImagesFPA}
          invalidImages={invalidImagesFPA}
          uploadIndex={uploadIndexFPA}
          allFiles={allFilesFPA}
        />
      )} */}
    </div>
  );
};

export default Projects;
